import React from "react";
import PropTypes from "prop-types";
import { ARGB_To_RGBA_Color } from "../constants";

Line.propTypes = {
  line: PropTypes.shape({
    X1: PropTypes.number.isRequired,
    X2: PropTypes.number.isRequired,
    Y1: PropTypes.number.isRequired,
    Y2: PropTypes.number.isRequired,
    StrokeThickness: PropTypes.number.isRequired,
    Stroke: PropTypes.string.isRequired,
  }).isRequired,
  fType: PropTypes.string.isRequired,
};

function Line(props) {
  const { line, fType } = props;
  const whenXNotEqual = Math.abs(line.X1 - line.X2);
  const width = line.X1 === line.X2 ? line.StrokeThickness : whenXNotEqual;
  const whenYNotEqual = Math.abs(line.Y1 - line.Y2);
  const height = line.Y1 === line.Y2 ? line.StrokeThickness : whenYNotEqual;
  return !(width === height && height === line.StrokeThickness) ? (
    <div
      style={{
        position: "absolute",
        top: `${line.Y1}px`,
        left: `${line.X1}px`,
        height: `${height}px`,
        width: `${width}px`,
        backgroundColor:
          fType === "NonAcord" ? ARGB_To_RGBA_Color(line.Stroke) : line.Stroke,
      }}
    ></div>
  ) : null;
}

export default Line;
